import { Injectable } from '@angular/core';
import { FirebaseService } from './firebase.service';
import { Company } from '../models/simskillsModels';

@Injectable({
  providedIn: 'root',
})
export class CompaniesService {
  constructor(private firebaseService: FirebaseService) {
  }
  
  public getCompanyByNameLowerCase(nameLowerCase: string): Promise<any> {
    return this.firebaseService.getDocumentByProperty('/companies/', 'name_lowercase', nameLowerCase);
  }
  
  public getCompanies() {
    return this.firebaseService.getDocument('/companies/');
  }
  
  public getCompany(companyId: string) {
    return this.firebaseService.getDocument('/companies/' + companyId);
  }
  
  public async addCompany(company: Company) {
    return await this.firebaseService.addDocument(`/companies/`, company);
  }
  
  public async editCompany(companyId: string, updatedData: Partial<Company>) {
    return await this.firebaseService.updateDocument('/companies', companyId, updatedData);
  }
  
  public getSettingByPath = (company: string, path: any): Promise<any> => {
    const url = `/companies/${company}/settings/${path}`;
    return this.firebaseService.getDocument(url);
  };
}
